<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top :color="snackbarColor"> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav class="hideOnPrint"/>
    <v-row dense class="hideOnPrint">
      <v-col cols="12" lg="3" xl="2">
        <ClientSide/>
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="behaviorReports"
            sort-by="DateTime"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Behavior Reports"
            height="550"
            :search="search"
            :server-items-length="totalServerItems"
            @pagination="getBehaviorReports"
            @update:options="getBehaviorReports"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Behavior Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                  dense
                  height="20"
                  @keyup.enter="searchItem(search)"
                  @change="searchItem(search)"
                >
                  <!-- <template v-slot:append>
                    <v-btn color="primary" class="mr-n3" @click="searchItem(search)">search</v-btn>
                  </template> -->
                </v-text-field>
                <v-spacer></v-spacer>
                <v-btn v-if="!isAuditorRole" color="#2b3990" dark @click="showAdd()">
                  <v-icon left>add</v-icon>
                  <span class="hidden-sm-and-down">Add Report</span>
                  <span class="hidden-md-and-up">Add</span>
                </v-btn>
                <v-btn class="primary ml-3" @click="printTable()">
                  <v-icon small>print</v-icon>
                  <span class="hidden-sm-and-down">Print</span>
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
                @keyup.enter="searchItem(search)"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewBehaviorReport(item)">
                mdi-eye
              </v-icon>

              <v-icon small @click="deleteBehaviorReport(item)" v-if="isAdmin">
                mdi-delete
              </v-icon>

            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getBehaviorReports()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint"/>
  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import reports from "@/mixins/reports";
import {mapActions} from "vuex";
import momentTz from "moment-timezone";
import {BEHAVIORS} from "src/constants/Behaviors";
import DateTimeUtil from "../../../utils/date-time.util";
import moment from "moment";


const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  mixins: [reports],
  data: function () {
    return {
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'DateTime',
          dataType: "Date"
        },
        {text: "Program", value: "Program"},
        {text: "Shift", value: "Shift"},
        {text: "Intensity", value: "Intensity"},
        {text: "Motivator", value: "Motivator"},
        {text: "Completed By", value: "CompletedBy"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      dialog: false,
      snackbarColor: "black",
      editBehaviorsBool: false,
      newBehaviorsBool: false,
      addNewBehaviorDialog: false,
      msg: false,
      search: "",
      text: "",
      behaviorReports: [],
      behaviors: BEHAVIORS,
      programs: ["Day Program", "Host Home", "Respite", "Residential", "Supported Living"],
      shifts: ["Day Program", "During School", "Morning - DSI", "Swing", "Grave", "Home Visit"],
      intensityKeys: ["No Behavior Observed", "1 - Mild", "2 - Moderate", "3 - Severe", "4 - Extreme"],
      motivatorKeys: ["No Behavior Observed", "1 - Anger", "2 - Anxiety", "3 - Get or obtain and object", "4 - Attention Seeking", "5 - Control/Independance",
        "6 - Sensory", "7 - Escape or to avoid", "8 - Other"],
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),
      tempData: [],
      behaviorTempData: [],
      behaviorList: [],
      titleForm: "New Behavior Report",
      behaviorID: "",
      newDateTime: new Date(),
      newProgram: "",
      newShift: "",
      newBehaviors: [],
      users: [],
      newOtherBehaviors: "",
      newIntensity: "",
      newMotivator: "",
      newOtherMotives: "",
      newAnticedent: "",
      newBehaviorEvent: "",
      newConsequences: "",
      newStaffAssessment: "",
      newNotification: "",
      newCompletedBy: "",
      signed: false,
      checkSignature: false,
      staff: localStorage.getItem("Name"),
      editedIndex: -1,
      isLoading: true,
      requiredRules: [
        v => !!v || 'This is required',
      ],
      itemsPerPage: 10,
      totalServerItems: 0,
      paginationInfo: {},
      timezone: momentTz.tz.guess(),
      isAdmin: false,
    };
  },

  computed: {
    client() {
      return {
        name: this.$store.state.clients?.client?.Name,
      };
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {},

  created() {
    this.getBehaviorReports();
    this.getBehaviors();
    if (localStorage.getItem('userRole') === "Client") {
      this.client = true;
    }
    if (localStorage.getItem('userRole') === "SuperAdministrator" ||
      localStorage.getItem('userRole') === "Administration" ||
      localStorage.getItem('userRole') === "Compliance Manager" ||
      localStorage.getItem('userRole') === "Client Services Manager") {
      this.isAdmin = true;
    }
  },

  methods: {
    ...mapActions({
      getClientInfo: "clients/getClient",
    }),

    initialize() {
      this.behaviorReports = [];
    },

    validate() {
      return this.$refs.form.validate()
    },

    viewBehaviorReport(item) {
      this.$router.push({
        path: `/behaviorReport/${this.clientID}/update/${item._id}`,
        query: {createBehaviorReport: false}
      });
    },

    showAdd() {
      this.$router.push({
        path: `/behaviorReport/${this.clientID}/new`,
        query: {createBehaviorReport: true}
      });
    },

    deleteBehaviorReport(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this behavior report?") &&
      this.behaviorReportDelete(id);

    },

    behaviorReportDelete(id) {
      axios.delete(`${url}/behaviorReports/${id}`)
        .then((response) => {
          this.getBehaviorReports();
          if (response.status === 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The behavior report has been deleted successfully.";
        });
    },


    getBehaviorReports(item = {page: 1, itemsPerPage: 10}) {
      this.paginationInfo = item
      const {sortBy = [], sortDesc = []} = item;
      let sortField = 'DateTime', sortDirection = -1;
      if (sortBy.length > 0) sortField = sortBy[0] === 'newDateTime' ? 'DateTime' : sortBy[0];
      if (sortDesc.length > 0) {
        sortDirection = 1;
        if (sortDesc[0] === undefined || sortDesc[0] === true) sortDirection = -1;
      }

      this.isLoading = true;
      axios.get(`${url}/behaviorReports/${this.clientID}?page=${item.page}&limit=${item.itemsPerPage}&search=${this.search}&sortField=${sortField}&sortDirection=${sortDirection}&tz=${this.timezone}`).then(res => {
        this.behaviorReports = [];
        this.tempData = res.data.behaviors.docs;

        this.behaviorReports = this.tempData.map(behavior => ({
          ...behavior,
          DateTime: DateTimeUtil.toLocalDateTime(behavior.DateTime),
          CompletedBy: this.formatSignature(behavior.CompletedBy)
        }));

        console.log({behaviors: this.behaviors});

        this.totalServerItems = res.data.behaviors.totalDocs;


      }).finally(() => this.isLoading = false);
    },

    getBehaviors() {
      axios.get(`${url}/behaviors/client/${this.clientID}`).then(async (response) => {
        this.behaviorList = response.data.behaviors;
      });
    },

    formatSignature(completedBy) {
      if (!completedBy || completedBy === "") {
        return "";
      }

      if (completedBy.includes("Z")) {
        const [name, utcTime] = completedBy.split(" - ");
        const cleanUtcTime = utcTime.replace("Z", "");
        const localTime = moment.utc(cleanUtcTime, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
        return `${name} - ${localTime}`;
      }

      return completedBy;
    },


    printTable() {

      let {page, itemsPerPage} = this.paginationInfo

      let headerFields = this.headers
        .filter((header) => header.value != "actions")
        .map((header) => header.value)
        .join(", ");

      let data = {
        query: {
          headers: headerFields,
          search: this.search,
          page: page,
          limit: itemsPerPage,
          name: this.client.name,
        },
        id: this.clientID,
        route: 'behaviorReports'
      }

      this.getReport(data)

    },


    searchItem(query) {
      this.search = query || ''
      this.getBehaviorReports()
    },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}


@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

</style>
